export default __webpack_public_path__ + "static/media/wip.396e397b.jpg";